import React, { createContext, useContext, useMemo } from 'react'

import { useMediaQuery } from '../hooks/useMediaQuery'

type MediaQueryType = 'isSm' | 'isMd' | 'isLg' | 'isXl' | 'is2lg'

type MediaQueryProviderType = Record<MediaQueryType, boolean>

const MediaQueryContext = createContext<MediaQueryProviderType>({
  isSm: false,
  isMd: false,
  isLg: false,
  isXl: false,
  is2lg: false,
})

const MediaQueryProvider: React.FC<{
  children: React.ReactNode | React.ReactNode[]
}> = ({ children }) => {
  const isSm = useMediaQuery('sm')
  const isMd = useMediaQuery('md')
  const isLg = useMediaQuery('lg')
  const isXl = useMediaQuery('xl')
  const is2lg = useMediaQuery('2lg')

  const value = useMemo(
    () => ({
      isSm,
      isMd,
      isLg,
      isXl,
      is2lg,
    }),
    [isSm, isMd, isLg, isXl, is2lg],
  )

  return (
    <MediaQueryContext.Provider value={value}>
      {children}
    </MediaQueryContext.Provider>
  )
}

const useMediaQueryContext = () => {
  const {
    isSm, isMd, isLg, isXl, is2lg,
  } = useContext(MediaQueryContext)

  return {
    isSm,
    isMd,
    isLg,
    isXl,
    is2lg,
  }
}

export { MediaQueryProvider, useMediaQueryContext }
